import IconBase from "./IconBase";

// A hash.
const NumberIcon = (props) => (
    <IconBase {...props}>
        <path d="M10 3.75L8 20.25" />
        <path d="M16.5 3.75l-2 16.5" />
        <path d="M4.25 9.25h15.25" />
        <path d="M3.75 14.75H19" />
    </IconBase>
);

export default NumberIcon;
